<template>
    <div class="customer" v-on:click="onClick(customer.id)">
        <div class="card-info-row">
            <div class="card-info">
                <p>{{ customer.name }}</p>
                <p>CPF: {{ customer.federalId | fmtCPF }}</p>
            </div>
        </div>
        <div class="card-info-row">
            <div class="card-info min">
                <label><b>Oportunidade</b></label>
                <p>{{ customer.optNetAmountSum | fmtMoney }}</p>
            </div>
            <div class="card-info min">
                <label><b>Esteira</b></label>
                <p>{{ customer.estNetAmountSum | fmtMoney }}</p>
            </div>
            <div class="card-info min">
                <label><b>Contratos</b></label>
                <p>{{ customer.cttNetAmountSum | fmtMoney }}</p>
            </div>
            <div class="card-info min">
                <label><b>Pagos</b></label>
                <p>{{ customer.cmsNetAmountSum | fmtMoney }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        customer: {
            type: Object,
            required: true
        },
        onClick: {
            type: Function,
            required: true
        },
    },
}
</script>
<style scoped>
    p {
        margin: 0;
    }

    .customer {
        width: 100%;
        display: flex;
        flex-direction: row;
        padding: 15px;
        border-radius: 5px;
        background-color: var(--white-color);
        cursor: pointer;
        justify-content: space-between;
    }

    .card-info {
        display: flex;
        flex-direction: column;
    }

    .card-info.min {
        min-width: 100px;
    }

    .card-info > label {
        font-size: 12px;
        color: var(--gray-color);
    }

    .card-info.avatar {
        flex-direction: row;
        align-items: center;
    }

    .card-info-row {
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .card-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: bold;
        color: var(--white-color);
        margin-right: 10px;
    }

    .card-info span {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Customer.vue